import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'md-tabs-bg-item',
  templateUrl: 'tabs-bg-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tabs__item',
    '[class.active]': 'active',
  },
})
export class TabsBgItemComponent {
  @Input() active = false;
  @Input() count: number | null | undefined = null;
  @Input() notificationCount: number | null | undefined = null;
}
